import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  useMediaQuery,
  useTheme,
  FormControlLabel,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { OuterContainer } from "../../EventCreation/styles";
import { Formik } from "formik";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import { EventNote } from "@material-ui/icons";
import { CustomDatePicker } from "../../common/FormInputs";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import moment from "moment";
import useUser from "../../../hooks/useUser";
import { navigate, useLocation } from "@reach/router";
import HostService from "../../../services/HostService";
import { generalValidationSchema } from "../../../helpers/validationSchema";
import useStatus from "../../../hooks/useStatus";
import _ from "lodash";
import RescheduleModal from "./components/Rescheduled";

const General = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [info, setInfo] = useState();
  const { userObject } = useUser();
  const [orgIds, setOrgIds] = useState([{ label: "", value: "" }]);
  const [hosts, setHosts] = useState([{ label: "", value: "" }]);
  const { setGlobalId } = useStatus();
  const [clickedButton, setClickedButton] = useState("");
  const [modal, setModal] = useState();
  const location = useLocation();

  const event_inputs = [
    {
      name: "eventName",
      label: "Event Name",
      type: "text",
      required: true,
      placeholder: "Enter Event name",
    },
    {
      type: "select",
      name: "orgId",
      label: "Organisation",
      required: true,
      autoWidth: true,
      hosts: hosts,
    },
    {
      type: "select",
      name: "mappedHost",
      label: "Add Host",
      required: true,
      autoWidth: true,
      multiple: true,
      hosts: hosts,
    },
    {
      name: "eventTemplate",
      label: "Event Template",
      type: "radio",
      required: true,
      menuItems: [
        {
          label: "Investor Call",
          name: "Invester Call",
          value: "Invester Call",
        },
        { label: "AGM", name: "AGM", value: "AGM" },
        { label: "Webcast", name: "Webcast", value: "Webcast" },
      ],
    },
    {
      name: "eventDate",
      label: "Event Date",
      type: "date",
      placeholder: "Enter Event date",
      required: true,
      //disabled: id?.id ? true : false,
    },
    {
      name: "eventTime",
      label: "Event Time",
      type: "time",
      required: true,
      //disabled: id?.id ? true : false,
    },
    {
      name: "eventTitle",
      label: "Event Title",
      type: "text",
      required: true,
      placeholder: "Enter Event title",
    },
    {
      name: "eventDuration",
      label: "Event Duration",
      type: "text",
      required: true,
      placeholder: "HH:MM",
    },
    {
      name: "eventDescription",
      label: "Event Description",
      type: "textarea",
      placeholder: "Eenter Event description",
    },
  ];

  const event_inputs_one = [
    {
      name: "eventStatus",
      label: "Event Status",
      type: "radio",
      required: true,
      menuItems: [
        { label: "Active", name: "active", value: "active" },
        {
          label: "Inactive",
          name: "inactive",
          value: "inactive",
        },
        // { label: "Archived", name: "archived", value: "archived" },
        {
          label: "Cancelled",
          name: "cancelled",
          value: "cancelled",
        },
      ],
    },
    {
      name: "registrationStatus",
      label: "Registration Status",
      type: "switch",
      menuItems: [
        { label: "Open", name: "open", value: "open" },
        { label: "Closed", name: "closed", value: "closed" },
      ],
    },
    {
      name: "hostApproval",
      label: "Host Approval",
      type: "switch",
    },
  ];

  const ordinator_info = [
    {
      name: "coordinatorName",
      label: "Name",
      type: "text",
      placeholder: "Enter coordinator name",
    },
    {
      name: "coordinatorphone",
      label: "Phone",
      type: "text",
      placeholder: "Enter coordinator phone",
    },
    {
      name: "coordinatorEmail",
      label: "Email",
      type: "text",
      placeholder: "Enter coordinator email",
    },
    {
      name: "coordinatorLocation",
      label: "Location",
      type: "text",
      placeholder: "Enter coordinator location",
    },
  ];

  const advanced_options = [
    {
      name: "micrositePrefix",
      label: "Microsite",
      type: "text",
      placeholder: "Enter microsite",
    },
    {
      name: "copyrightText",
      label: "Copyright Text",
      type: "text",
      placeholder: "Enter copy right text",
    },
    {
      name: "websiteAddress",
      label: "Website Address",
      type: "text",
      placeholder: "Enter website address",
    },
  ];

  const playback_info = [
    {
      name: "playbackRequired",
      label: "Playback Required",
      type: "switch",
    },
    {
      name: "playbackVideo",
      label: "Playback Video",
      type: "upload",
      accept: ".mp4",
    },
    {
      name: "playbackDuration",
      label: "Playback Duration",
      type: "radio",
      menuItems: [
        {
          name: "none",
          label: "None",
          value: "none",
        },
        {
          name: "oneMonth",
          label: "1 Month",
          value: "oneMonth",
        },
        {
          name: "oneYear",
          label: "1 Year",
          value: "oneYear",
        },
        {
          name: "sevenDays",
          label: "7 Days",
          value: "sevenDays",
        },
        {
          name: "threeMonth",
          label: "3 Month",
          value: "threeMonth",
        },
        {
          name: "customDate",
          label: "Custom Date",
          value: "customDate",
        },
      ],
    },
  ];
  const buttons = [
    {
      label: id?.id ? "SAVE" : "SAVE & CLOSE",
      color: "default",
      primary: true,
      // disabled: id?.id ? false : true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      disabled: id?.id ? false : true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  useEffect(() => {
    (async function getOrganizationData() {
      try {
        const response = await HostService.activeOrganisation();
        setOrgIds(
          response?.organizations?.map((item) => {
            return {
              label: item.orgName,
              value: item?.orgId,
            };
          }),
        );
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async function getActiveHosts() {
      try {
        const response = await HostService.getActiveHosts();
        setHosts(
          response?.activeHosts?.map((item) => {
            return {
              label: item?.firstName + " " + item?.lastName,
              value: parseInt(item?.hostId),
              hostEmail: item?.mailId,
              orgId: item.orgId,
            };
          }),
        );
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "general");
        setInfo(response);
        localStorage.setItem("communicate-tab", location?.state.communicateTab);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } else {
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo(id) {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id, "general");
      setInfo(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description submit general
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const hostId = "hostId";
      const hostEmail = "hostEmail";
      const hostName = "hostName";
      const payload = {
        ...values,
        eventDate: moment(values?.eventDate).format("DD/MM/YYYY"),
        orgId: values.orgId,
        eventStatus: values?.eventStatus,
        orgName: values.organization.orgName,
        eventTime: moment(values?.eventTime).format("HH:mm"),
        hostApproval: values?.hostApproval,
        registrationStatus: values?.registrationStatus ? "open" : "closed",
        playbackInfo: {
          playbackRequired: values?.playbackInfo?.playbackRequired,
          playbackDuration:
            values?.playbackInfo?.playbackDuration === "customDate"
              ? moment(values?.playbackDurationCustomDate).format("DD/MM/YYYY")
              : values?.playbackInfo?.playbackDuration,
          playbackVideo: values?.playbackInfo?.playbackVideo,
          playbackDurationCustomDate:
            values?.playbackInfo?.playbackDuration === "customDate"
              ? "customDate"
              : "",
        },
        mappedHost: hosts
          .filter((item) => item?.orgId === values?.orgId)
          .filter((item) =>
            values.mappedHost.some((id) => id === parseInt(item.value)),
          )
          .map((item) => ({
            [hostId]: item?.value,
            [hostEmail]: item?.hostEmail,
            [hostName]: item?.label,
          })),
      };
      if (id?.id) {
        const response = await EventService.updateEvent(id?.id, payload);
        if (response?.message) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
        }
        if (clickedButton === "save") {
          getEventInfo(id?.id);
        } else {
          navigate(`/dashboard/eventmanager/form-settings/${id?.id}`);
        }
      } else {
        const response = await EventService.eventInfo(payload);
        if (response) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
        }
        navigate(`/dashboard/eventmanager/home`);
        // getEventInfo(response?.event?.id);
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  let mappedValue = [];

  const array = hosts.filter((item) =>
    info?.mappedHost?.some((item1) => parseInt(item1?.hostId) === item?.value),
  );

  array.map((item) => mappedValue.push(parseInt(item.value)));

  /*

  const onHandleChange = (event, setFieldValue, name) => {
    const value = event.target.value;
    const seconds = Math.max(0, getSecondsFromHHMMSS(value));

    const time = toHHMMSS(seconds);
    setFieldValue(name, time);
  };

  const getSecondsFromHHMMSS = (value) => {
    const [str1, str2, str3] = value.split(":");

    const val1 = Number(str1);
    const val2 = Number(str2);
    const val3 = Number(str3);

    if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
      return val1;
    }

    if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
      return val1 * 60 + val2;
    }

    if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
      return val1 * 60 * 60 + val2 * 60 + val3;
    }

    return 0;
  };

  const toHHMMSS = (secs) => {
    const secNum = parseInt(secs.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [hours, minutes, seconds]
      .map((val) => (val < 10 ? `0${val}` : val))
      .filter((val, index) => val !== "00" || index > 0)
      .join(":")
      .replace(/^0/, "");
  };

  */

  const actions = [
    {
      text: "Create New Event",
      props: {
        onClick: () => {
          navigate("/dashboard/eventmanager/event-details");
          setGlobalId("");
        },
      },
      hidden: id?.id ? false : true,
    },
    {
      text: "Rescheduled",
      props: {
        onClick: () => {
          setModal({
            state: true,
            eventId: id?.id,
            eventDate:
              moment(info?.eventDate, "DD/MM/YYYY")
                .set({
                  hour: 7,
                  minute: 29,
                  second: 0,
                  millisecond: 0,
                })
                .toISOString() || "",
            eventTime: moment(info?.eventTime, "HH:mm:ss").toISOString() || "",
          });
        },
      },
      hidden: id?.id ? false : true,
    },
  ];

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      default:
        break;
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "General",
                info?.eventName
                  ? `${info?.eventName} (${info?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "General"]
        }
        {...{ actions, onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            eventmanagerId: userObject?.emId,
            eventName: info?.eventName || "",
            eventTemplate: info?.eventTemplate || "",
            eventDate:
              moment(info?.eventDate, "DD/MM/YYYY")
                .set({
                  hour: 7,
                  minute: 29,
                  second: 0,
                  millisecond: 0,
                })
                .toISOString() || "",
            eventTime: moment(info?.eventTime, "HH:mm:ss").toISOString() || "",
            eventStatus: info?.eventStatus || "",
            eventTitle: info?.eventTitle || "",
            eventDescription: info?.eventDescription || "",
            registrationStatus:
              info?.registrationStatus === "open" ? true : false || "",
            orgId: parseInt(info?.orgId) || "",
            organization: info?.orgName || "",
            eventDuration: info?.eventDuration || "",
            hostApproval: info?.hostApproval || false,
            mappedHost: mappedValue,
            playbackDurationCustomDate: moment(
              info?.playbackInfo?.playbackDuration,
              "DD/MM/YYYY",
            )
              .set({
                hour: 7,
                minute: 29,
                second: 0,
                millisecond: 0,
              })
              .toISOString()
              ? moment(info?.playbackInfo?.playbackDuration, "DD/MM/YYYY")
                  .set({
                    hour: 7,
                    minute: 29,
                    second: 0,
                    millisecond: 0,
                  })
                  .toISOString()
              : "",
            coordinatorInfo: {
              coordinatorName: info?.coordinatorInfo?.coordinatorName || "",
              coordinatorphone: info?.coordinatorInfo?.coordinatorphone || "",
              coordinatorEmail: info?.coordinatorInfo?.coordinatorEmail || "",
              coordinatorLocation:
                info?.coordinatorInfo?.coordinatorLocation || "",
            },
            advanceOptions: {
              micrositePrefix: info?.advanceOptions?.micrositePrefix || "",
              copyrightText: info?.advanceOptions?.copyrightText || "",
              websiteAddress: info?.advanceOptions?.websiteAddress || "",
            },
            playbackInfo: {
              playbackRequired: info?.playbackInfo?.playbackRequired || "",
              playbackVideo: info?.playbackInfo?.playbackVideo || "",
              playbackDuration:
                info?.playbackInfo?.playbackDurationCustomDate === "customDate"
                  ? "customDate"
                  : info?.playbackInfo?.playbackDuration || "",
              playbackDurationCustomDate: moment(
                info?.playbackInfo?.playbackDuration,
                "DD/MM/YYYY",
              )
                .set({
                  hour: 7,
                  minute: 29,
                  second: 0,
                  millisecond: 0,
                })
                .toISOString()
                ? moment(info?.playbackInfo?.playbackDuration, "DD/MM/YYYY")
                    .set({
                      hour: 7,
                      minute: 29,
                      second: 0,
                      millisecond: 0,
                    })
                    .toISOString()
                : "",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={generalValidationSchema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            handleChange,
            resetForm,
            setFieldValue,
          }) => (
            <FormContainer>
              <Container style={{ justifyContent: "flex-end" }}>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>General</Heading>
                  <Grid container spacing={3} style={{ padding: 16 }}>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      <Paper
                        style={{
                          padding: 16,
                          border: "1px solid #e1e3ee",
                        }}
                      >
                        <GridLabel>Event Info</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {event_inputs.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  handleBlur,
                                  setFieldValue,
                                  errors,
                                }}
                                menuItems={
                                  item.name === "mappedHost"
                                    ? values?.orgId
                                      ? hosts.filter(
                                          (host) => host.orgId === values.orgId,
                                        )
                                      : item.menuItems
                                    : item?.name === "orgId"
                                    ? orgIds
                                    : item.menuItems
                                }
                                multiple={item.multiple}
                                selectedItems={values.mappedHost}
                                direction={"row"}
                                name={item.name}
                                touched={touched[item.name]}
                                value={values[item.name]}
                                error={errors[item.name]}
                                helperText={errors[item.name]}
                                eventId={info?.eventId}
                                // handleBlur={(e) => {
                                //   if (item.name === "eventDuration") {
                                //     onHandleChange(
                                //       e,
                                //       setFieldValue,
                                //       "eventDuration",
                                //     );
                                //   }
                                // }}
                              />
                            </Grid>
                          ))}
                          {event_inputs_one.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  setFieldValue,
                                  errors,
                                }}
                                direction={"row"}
                                name={item.name}
                                value={values[item.name]}
                                error={errors[item.name]}
                                helperText={errors[item.name]}
                                eventId={info?.eventId}
                                touched={touched[item.name]}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Co-ordinator Info</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {ordinator_info.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                value={values.coordinatorInfo[item.name]}
                                name={`coordinatorInfo.${item.name}`}
                                touched={["coordinatorInfo"]?.[item.name]}
                                error={
                                  errors["coordinatorInfo"]?.[item.name] &&
                                  touched["coordinatorInfo"]?.[item.name]
                                }
                                helperText={
                                  touched["coordinatorInfo"]?.[item.name] &&
                                  errors["coordinatorInfo"]?.[item.name]
                                }
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                      <Paper
                        style={{
                          padding: 16,
                          border: "1px solid #e1e3ee",
                          marginTop: "22px",
                        }}
                      >
                        <GridLabel>Advance Options</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {advanced_options.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                value={values.advanceOptions[item.name]}
                                name={`advanceOptions.${item.name}`}
                                touched={["advanceOptions"]?.[item.name]}
                                error={
                                  errors["advanceOptions"]?.[item.name] &&
                                  touched["advanceOptions"]?.[item.name]
                                }
                                helperText={
                                  touched["advanceOptions"]?.[item.name] &&
                                  errors["advanceOptions"]?.[item.name]
                                }
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                      <Paper
                        style={{
                          padding: 16,
                          border: "1px solid #e1e3ee",
                          marginTop: "22px",
                        }}
                      >
                        <GridLabel>Playback Info</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {playback_info.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  setFieldValue,
                                  errors,
                                }}
                                touched={["playbackInfo"]?.[item.name]}
                                value={values.playbackInfo?.[item.name]}
                                name={`playbackInfo.${item.name}`}
                                error={
                                  errors["playbackInfo"]?.[item.name] &&
                                  touched["playbackInfo"]?.[item.name]
                                }
                                helperText={
                                  touched["playbackInfo"]?.[item.name] &&
                                  errors["playbackInfo"]?.[item.name]
                                }
                                accept={item.accept}
                                direction={"row"}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        {values.playbackInfo["playbackDuration"] ===
                        "customDate" ? (
                          <Grid
                            container
                            spacing={2}
                            style={{
                              justifyContent: "center",
                              marginBottom: "5px",
                            }}
                          >
                            <FormControlLabel
                              labelPlacement="start"
                              label={<SwitchLabel>{""}</SwitchLabel>}
                              control={
                                <CustomDatePicker
                                  inputVariant="outlined"
                                  format={"DD/MM/YYYY"}
                                  minDate={new Date()}
                                  value={values?.playbackDurationCustomDate}
                                  name={"playbackDurationCustomDate"}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "playbackDurationCustomDate",
                                      e,
                                    )
                                  }
                                  style={{ marginTop: 6, width: "190px" }}
                                  InputProps={{
                                    endAdornment: (
                                      <>
                                        <InputAdornment position="end">
                                          <IconButton
                                            color="inherit"
                                            edge="end"
                                          >
                                            <EventNote
                                              style={{ fill: "#00aeef" }}
                                            />
                                          </IconButton>
                                        </InputAdornment>
                                      </>
                                    ),
                                  }}
                                />
                              }
                            />
                          </Grid>
                        ) : null}
                      </Paper>
                    </Grid>
                    <FormControl>
                      <ButtonContainer>
                        {buttons.map((button) => (
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            disabled={button.disabled}
                            onClick={() =>
                              handleButtonClick(button, resetForm, handleSubmit)
                            }
                          >
                            {button.label}
                          </PrimaryCTAButton>
                        ))}
                      </ButtonContainer>
                    </FormControl>
                  </Grid>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
      {modal?.state && (
        <RescheduleModal {...{ modal, setModal }} getEventInfo={getEventInfo} />
      )}
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default General;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "18px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

const SwitchLabel = styled(Typography)(({ isBigScreen }) => ({
  width: isBigScreen ? "350px" : "120px",
  color: " #293461",
  fontSize: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;
